createSafeModule('app.agenda', [
    'ui.router',
    'ngResource',
    'lazyLoad'
]);